<template>
    <div class="l content_right role_management">
        <el-tabs v-model="active">
            <el-tab-pane label="IDE" name="ide">
                <list v-if="active == 'ide'" :platapplicationcode="1"></list>
            </el-tab-pane>
            <el-tab-pane label="租户管理" name="tenant">
                <list v-if="active == 'tenant'" :platapplicationcode="2"></list>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import list from './list'
    export default {
        data: function(){
            return {
                active: 'ide'
            }
        },
        components: {
            list
        },
        created: function(){
        },
        methods: {
            
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?4da519db